import classNames from 'classnames';

interface SkipButtonProps {
  isDisabled?: boolean;
  // Once a subscriber has subscribed to a row individually, the dismiss button
  // toggles to "Next" instead of "Skip".
  hasSubmitted?: boolean;
  onClick: () => void;
  translations?: Record<string, string>;
}

export const SkipButton: React.FC<SkipButtonProps> = ({
  isDisabled = false,
  hasSubmitted = false,
  onClick,
  translations,
}) => {
  const label = hasSubmitted
    ? translations?.['recommendations.modal.next'] || 'Next'
    : translations?.['recommendations.modal.skip'] || 'Skip';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isDisabled}
      className={classNames(
        'px-4 py-1 rounded-[var(--site-theme-border-radius,6px)] bg-transparent text-[var(--site-theme-text-on-background-color,#222222)] font-medium justify-center items-center duration-300',
        isDisabled ? 'opacity-30 cursor-not-allowed' : 'opacity-50 hover:opacity-80',
      )}
      style={{ fontFamily: 'var(--site-theme-button-font)' }}
    >
      {label}
    </button>
  );
};
